<template>
  <v-layout fill-height column>
    <div class="flex-fill" :class="{'pt-10' : isContentVideo}">
      <iframe
          id="iframeSolution"
          :src=iframe.src
          :style=iframe.style
          height="100%"
          width="100%"
          :scrolling="iframe.scrolling"
          frameborder="0"
      >
      </iframe>
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="next()" :current="current" :total="total"
                    :disabledNext="disabledNext" />
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
import store from '../../../store'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    textarea: '',
    disabledNext: false,
    free: 'N',
    cmplt: false,
    ques: [],
    libNo: '',
    type: '',
    iframe: {
      src: '',
      style: 'border:none; vertical-align: top;',
      // height: window.innerHeight - 108,
      // width: '100%',
      scrolling: 'yes'
    },
  }),
  computed: {
    popupYn () {
      return this.$route.query.popupYn
    },
    isContentVideo () {
      // Library type video 일 경우에만 상단 공간이 필요
      return this.popupYn && this.type === '05' && this.libNo
    }
  },
  components: {
    FooterBtnsNext,
  },
  mounted() {
  },
  watch: {
    current() {
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.disabledNext = false,
          this.free = 'N',
          this.cmplt = false,
          this.ques = [],
          this.libNo = '',
          this.type = '',
          this.getUnitDetailUse()
    }
  },
  created() {
    this.getUnitDetailUse()
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
            if (res.success) {
              // 질문 리스트
              res.data.unitDtlQuesList.forEach((quesEl) => {
                // 질문 셋팅
                this.ques.push(quesEl.ques)
                this.libNo = quesEl.ques
              });

              if (this.libNo != '') {
                this.getLibraryDetailOne(this.libNo)
              }

            } else {
              console.log(res.msg)
              // this.answer = [];
            }
          })
          .catch(error => {
            console.error(error)
            // this.answer = [];
          })
          .finally(() => {
          })
    },
    async getLibraryDetailOne(libNo) {
      this.iframe.src = `${window.location.protocol}//${window.location.host}/user/fo/library/solution?libNo=${libNo}&popupYn=${this.popupYn !== undefined ? this.popupYn : null}`
    },
    // async getLibraryDetailOne(libNo) {
    //   await store.dispatch('getLibraryDetailOne', this.$_payload({'libNo': libNo}))
    //       .then(res => {
    //         if (res.success) {
    //           if (res.data != null) {
    //             this.type = res.data.type
    //           }
    //
    //           // console.log("this.libNo : ", this.libNo)
    //           // console.log("this.type : ", this.type)
    //           // console.log("this.popupYn : ", this.popupYn)
    //
    //           // this.iframe.src = window.location.protocol+"//"+window.location.host+"/user/fo/SolutionLib?libNo="+this.libNo+"&type="+this.type
    //           this.iframe.src = `${window.location.protocol}//${window.location.host}/user/fo/solution/library/${this.type}?libNo=${this.libNo}&popupYn=${this.popupYn !== undefined ? this.popupYn : null}`
    //
    //         } else {
    //           console.log(res.msg)
    //         }
    //       })
    //       .catch(error => {
    //         console.error(error)
    //       })
    //       .finally(() => {
    //       })
    // },
    next() {
      this.$emit('next')
    },
  },

};
window.addEventListener("message", function (eve) {
  if (eve.data.params == 'close') {
    window.closeModal()
  }
});
</script>
<style lang="scss" scoped>
.iframeClass {
  //margin: 0 -23px;
}
</style>
